// Pattern: docs/design-patterns/frontend/api-client — service layer (no error catching)

import type { PatternDetail, PatternExamples, PatternManifest, PatternManifestRaw } from '~/types';

import { apiRequest } from './client';

const DESIGN_PATTERNS_BASE = '/design-patterns';

export async function getPattern(patternId: string): Promise<PatternDetail> {
  const response = await apiRequest<PatternDetail>(`${DESIGN_PATTERNS_BASE}/${patternId}`);
  return response.data;
}

export async function getPatternExamples(
  patternId: string,
  techStack: string,
): Promise<PatternExamples> {
  const response = await apiRequest<PatternExamples>(
    `${DESIGN_PATTERNS_BASE}/${patternId}/examples/${techStack}`,
  );
  return response.data;
}

export async function getPatternManifest(): Promise<PatternManifest> {
  const response = await apiRequest<PatternManifestRaw>(`${DESIGN_PATTERNS_BASE}/manifest`);
  const raw = response.data;

  // Merge anti_patterns into patterns with explicit type field
  const patterns = raw.patterns.map(p => ({ ...p, type: p.type ?? ('pattern' as const) }));
  const antiPatterns = (raw.anti_patterns ?? []).map(p => ({
    ...p,
    type: 'anti-pattern' as const,
  }));

  return {
    version: raw.version,
    generated_at: raw.generated_at,
    patterns: [...patterns, ...antiPatterns],
  };
}
